import { Directive } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';

@Directive({
  selector: 'ng-select',
  standalone: false,
  host: {
    '(mousedown)': 'openOnValueClick($event)'
  }
})
export class NgSelectValueClickDirective {
  constructor(private readonly ngSelect: NgSelectComponent) {}

  public openOnValueClick(event: MouseEvent): void {
    if (!(event.target instanceof HTMLElement)) {
      return;
    }

    if (!event.target.closest('.ng-value')) {
      return;
    }

    if (event.target.closest('.ng-value-icon')) {
      return;
    }

    this.ngSelect.open();
  }
}
